import { ReactElement, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useControlStore, useStructuralPlanningStore } from '@editorStores'
import { getConfigureWindLoadResults } from '@queries'
import WindLoadCPEAreaMeshElement from '../WindLoadCPEAreaMeshElement'

const WindLoadCPEAreasMesh = (): ReactElement => {
  const { projectId }: { projectId?: string } = useParams()
  const windLoadDirection = useStructuralPlanningStore(state => state.windLoadDirection)
  const visibility = useControlStore(state => state.structuralPlanningElementVisibility)
  const showWindLoadCPEAreas = visibility.windLoadZones

  const { data: windLoadConfigResult } = useQuery({
    queryKey: getConfigureWindLoadResults.getKey(projectId),
    queryFn: () => getConfigureWindLoadResults.request(projectId),
    enabled: !!projectId,
  })

  const cpeAreas = useMemo(() => {
    if (!windLoadConfigResult) return []

    let directionResult
    if (windLoadDirection === 'Direction0') {
      directionResult = windLoadConfigResult.result_000
    } else if (windLoadDirection === 'Direction90') {
      directionResult = windLoadConfigResult.result_090
    } else if (windLoadDirection === 'Direction180') {
      directionResult = windLoadConfigResult.result_180
    } else if (windLoadDirection === 'Direction270') {
      directionResult = windLoadConfigResult.result_270
    }

    if (!directionResult?.cpe_projection_result?.cpe_projections) return []

    // Convert the areas to an array format
    return Object.entries(directionResult.cpe_projection_result.cpe_projections).map(
      ([id, area]) => ({
        id,
        ...(area as CPEArea),
      }),
    )
  }, [windLoadConfigResult, windLoadDirection])

  if (!cpeAreas.length) return <></>

  return (
    <>
      {showWindLoadCPEAreas &&
        cpeAreas.map(area => <WindLoadCPEAreaMeshElement key={area.id} area={area} />)}
    </>
  )
}

export default WindLoadCPEAreasMesh
